/*!
 * @license
 * SPDX-License-Identifier: LicenseRef-cloudEQ-Proprietary
 * Copyright (c) 2026-present cloudEQ Inc. All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL.
 *
 * This source code, including all associated files, documentation, and
 * compiled forms, is the exclusive property of cloudEQ Inc. and is
 * protected by copyright, trade secret, and other intellectual property laws.
 *
 * This software is licensed, not sold, solely for use by authorized
 * licensees under the terms of a written license agreement with
 * cloudEQ Inc. Unless expressly permitted by that agreement, you may not
 * copy, modify, merge, distribute, sublicense, sell, publish, reverse
 * engineer, decompile, disassemble, or create derivative works of this
 * software, in whole or in part, by any means.
 *
 * Access to this file does not grant any license or right to use it.
 * Unauthorized use, reproduction, or disclosure is strictly prohibited and
 * may result in civil and criminal penalties.
 *
 * Contact: legal@cloudeq.com
 */

import { SEARCH_HINT } from '@/lib/shortcut';

/**
 * The `⌘K` / `Ctrl K` badge that sits inside a search box.
 *
 * **Shown only while the box is empty** — once there is a search in it, a hint
 * about how to get here is answering a question nobody is asking any more — and
 * only from `laptop` up, which is both where these boxes are wide enough to
 * spare the room and where there is a keyboard to press it with.
 *
 * `pointer-events-none` so clicking the badge still lands in the field: it looks
 * like part of the input and has to behave like it.
 *
 * The parent must be `relative`, and the input needs right padding at `laptop`
 * so the text never runs under this.
 */
export function SearchHint({ when }: { when: boolean }) {
  if (!when) return null;
  return (
    <kbd className="pointer-events-none absolute right-2 hidden select-none items-center rounded border border-border bg-surface px-1.5 py-0.5 font-sans text-2xs font-semibold text-ink-faint laptop:flex">
      {SEARCH_HINT}
    </kbd>
  );
}
